import React, { useContext, useState, useEffect, useMemo } from 'react'
import { Icon, Menu,  Statistic, /* Loader, */ Popup} from 'semantic-ui-react'
import _ from 'lodash'
import { GetReservationTotals } from '../../api/services/pms'
import { onWarning, onError } from '../../components/shared/messages'
import PropTypes from 'prop-types'
import { Currencies } from '../../components/shared/currencies'
import { GroupReservationContext } from './context'
import { useMessageResources, useTextResources } from '../../language'

const GroupTotals = ({HotelID}) => {
    const { state } = useContext(GroupReservationContext)
    const [total, setTotal] = useState(0)
    const [balance, setBalance] = useState(0)
    const [currency, setCurrency] = useState(0)
    const text = useTextResources()
    const message = useMessageResources()
    
    // Only recalculate when reservation IDs actually change, not on every state update
    // Also refresh when totalsRefreshKey changes (after save operations)
    const reservationIds = useMemo(() => {
        const reservations = state.ReservationGroup?.ReservationGroupReservations || []
        const ids = reservations
            .map(r => r?.Reservation?.Id || r?.ReservationID)
            .filter(Boolean)
            .map(Number)
        ids.sort((a, b) => a - b)
        const totalAmount = _.sumBy(reservations, r => parseFloat(r?.Reservation?.TotalAmountProductCurrentAfterTax ?? 0))
        return `${ids.join(',')}-${totalAmount}-${state.totalsRefreshKey || 0}`
    }, [state.ReservationGroup?.ReservationGroupReservations, state.totalsRefreshKey])
        
    useEffect(()=>{
        (async ()=>{
            try {                                
                const reservations = state.ReservationGroup?.ReservationGroupReservations
                
                if (!reservations?.length) return;

                const spec = {                   
                    TargetCurrencyId: 2   
                }; 

                let idsIndex = 0
                const reservationIdsSpec =_.reduce(reservations, (result, reservation)=>{
                    const id = reservation?.Reservation?.Id || reservation?.ReservationID
                    if (id) {
                        result[`ReservationIDs[${idsIndex}]`] = id
                        idsIndex += 1
                    }
                    return result
                }, {
                    HotelID: HotelID});

                const totals = await GetReservationTotals({...reservationIdsSpec,...spec}) 
            
                if (totals && totals.length) {
                    setTotal(_.sumBy(totals, t=>t.TotalAmountDebitAfterTax) || 0)
                    setBalance(_.sumBy(totals, t=>t.TotalAmountDebitAfterTax + t. TotalAmountCreditAfterTax) || 0)
                    setCurrency(totals[0].CurrencyID)
                }
            } catch (error) {
                error.error.status === 400?onWarning(error):onError(error)
            }
        })()
    }, [reservationIds, HotelID])

    return (
        <React.Fragment>
            <Menu.Item header fitted='vertically'>
                <Icon size="huge" className="icon-wallet2"/>
                <Statistic size="tiny">
                    <Statistic.Value>{/* <Loader active={loading} size="mini"/> */}{total.toFixed(2)}{Currencies[currency]?.symbol}</Statistic.Value>
                    <Statistic.Label>{text('PriceAfterTax')} <Popup position="top right" trigger={ <Icon name="info" circular size="tiny"/> } content={message("DisplaysTotalGroupPriceIncludingAllFoliosAfterTax")}/>
                    </Statistic.Label>
                </Statistic>
            </Menu.Item>
            <Menu.Item header fitted='vertically'>
                <Icon size="huge" className="icon-money-bag" />
                <Statistic size="tiny" color="red">
                    <Statistic.Value>{/* <Loader active={loading} size="mini"/> */}{balance.toFixed(2)}{Currencies[currency]?.symbol}</Statistic.Value>
                    <Statistic.Label>{text('Balance')} <Popup position="top right" trigger={ <Icon name="info" circular size="tiny"/> } content={message("DisplaysRestGroupPaymentIncludingAllFoliosAfterTax")}/>
                    </Statistic.Label>
                </Statistic>
            </Menu.Item>
        </React.Fragment>
    )
}

GroupTotals.propTypes = {
    HotelID: PropTypes.any
}

export default GroupTotals